(function () {
  if (!('customElements' in window)) return;

  customElements.define('sticky-add-to-cart', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var el = this;
      var sectionId = this.dataset.section;
      var priceEl = document.getElementById('price-' + sectionId);
      var stickyPrice = this.querySelector('[data-sticky-price]');

      function syncPrice() {
        if (!priceEl || !stickyPrice) return;
        var node = priceEl.querySelector('.price-item--sale:not([hidden])') ||
          priceEl.querySelector('.price-item--regular') ||
          priceEl.querySelector('.price-item');
        if (node) stickyPrice.textContent = node.textContent.trim();
      }
      syncPrice();
      if (priceEl && 'MutationObserver' in window) {
        new MutationObserver(syncPrice).observe(priceEl, {
          subtree: true, childList: true, characterData: true
        });
      }

      // Show the bar once the main Add-to-cart button scrolls out of view.
      var mainAtc = document.getElementById('ProductSubmitButton-' + sectionId) ||
        document.querySelector('[id^="ProductSubmitButton-"]');
      if ('IntersectionObserver' in window && mainAtc) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { el.hidden = entry.isIntersecting; });
        }, { rootMargin: '0px 0px -10px 0px' }).observe(mainAtc);
      }
    }
  });
})();
